import { TProduct } from "./cart-provider";
import cartStyles from "./cart.module.scss";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";
import { memo, useRef } from "react";
import DotArrowLeft from "assets/icons/DotArrowLeft";
import DotArrowRight from "assets/icons/DotArrowRight";
import "swiper/css";

const swipeLen = 4;

const ProductCarousel = memo(
  ({
    items,
    onItemClick,
  }: {
    items: TProduct[];
    onItemClick?: (item: TProduct) => void;
  }) => {
    const swiper = useRef<SwiperClass | null>(null);

    const arrowStyle = {
      paddingTop: 24,
      cursor: "pointer",
    };

    return (
      <div style={{ display: "flex", gap: 4, alignItems: "flex-start" }}>
        <div
          role="button"
          onClick={() => {
            for (let i = 0; i < swipeLen; i++) {
              swiper.current?.slidePrev?.();
            }
          }}
          style={arrowStyle}
        >
          <DotArrowLeft />
        </div>
        <Swiper
          spaceBetween={8}
          slidesPerView={Math.min(swipeLen, items.length)}
          grabCursor={true}
          loop={false}
          resistance={false}
          resistanceRatio={0}
          // @ts-ignore
          onSwiper={(sw) => (swiper.current = sw)}
        >
          {items.map((item) => {
            return (
              <SwiperSlide key={item.id}>
                <div
                  key={item.id}
                  className={cartStyles["product-carousel__product"]}
                  onClick={onItemClick ? () => onItemClick(item) : undefined}
                >
                  <img
                    src={item.images[0]}
                    className={cartStyles["cart-item__image"]}
                    style={{ width: 60, height: 60 }}
                    alt={item.name}
                  />

                  <div
                    style={{
                      fontSize: 11,
                      letterSpacing: -0.2,
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item.name}
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div
          role="button"
          onClick={() => {
            for (let i = 0; i < swipeLen; i++) {
              swiper.current?.slideNext?.();
            }
          }}
          style={arrowStyle}
        >
          <DotArrowRight />
        </div>
      </div>
    );
  }
);

export default ProductCarousel;
